import addError from '../../../utils/error.jsx';

export function request(target, {sport}) {
    return {
        type: 'LADDER_COPY_REQUEST',
        target,
        sport
    };
}

export function error(target, errors) {
    addError(errors);

    return {
        type: 'LADDER_COPY_ERROR',
        errors,
        target
    };
}

export function finish(target, {prices}) {
    return {
        type: 'LADDER_COPY_FINISH',
        prices,
        target
    };
}
